import Select from "react-select"
import { useTranslation } from "react-i18next"

const options = [
  { value: "Mr", label: "Mr", id: 0 },
  { value: "Mrs", label: "Mrs", id: 1 },
  { value: "Dr", label: "Dr", id: 2 },
  { value: "المكرمة", label: "المكرمة", id: 3 },
  { value: "المكرم", label: "المكرم", id: 4 },
  { value: "الاستاذ", label: "الاستاذ", id: 5 },
  { value: "الاستاذة", label: "الاستاذة", id: 6 },
  { value: "الدكتور", label: "الدكتور", id: 7 },
  { value: "الدكتورة", label: "الدكتورة", id: 8 },
  { value: "الشيخ", label: "الشيخ", id: 9 },
  { value: "الشيخة", label: "الشيخة", id: 10 },
]

const SelectGuest = ({ placeholder, validation, value, handeInput }: any) => {
  const { t } = useTranslation()

  return (
    <div
      className={validation.suffix ? "select-row input-error" : "select-row"}
    >
      <Select
        // menuIsOpen={true}
        classNamePrefix="select-guest"
        placeholder={placeholder}
        options={options}
        value={options.find((e) => e.value === value)}
        onChange={(val) => {
          handeInput("suffix", val?.value)
        }}
      />

      <label className={"active"} htmlFor="">
        {placeholder}
      </label>

      {validation.suffix && (
        <span className="input-item__error error mt-1">
          {validation.suffix}
        </span>
      )}
    </div>
  )
}

export default SelectGuest
